import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { SMSService } from '../../../shared/services/sms.service';
import { CaseService } from '../../../shared/services/case.service';
import { CorrespondenceTimelineService } from '../../../shared/services/correspondence-timeline.service';
import { faExclamationCircle } from '@fortawesome/pro-light-svg-icons';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-sms',
  templateUrl: './sms.component.html',
  styleUrls: ['./sms.component.scss']
})
export class SmsComponent implements OnInit {

  @Input() caseId: number = -1;
  @Input() optedIn: boolean = false;
  @Input() smsObj: any;

  sendingSMS: boolean = false;
  readOnly = false;
   

  faExclamationCircle = faExclamationCircle;

  smsDetails = this.fb.group({
    phoneNumber: ['', Validators.required],
    message: ['', Validators.required],
  });

  constructor(public activeModal: NgbActiveModal,
              private fb: UntypedFormBuilder,
              private smsService: SMSService,
              private correspondenceTimelineService: CorrespondenceTimelineService) {
     
  }

  ngOnInit() {
     if(this.smsObj != null)
      {
        this.readOnly = true;
        this.smsDetails.controls['phoneNumber'].patchValue(this.smsObj.to);
        this.smsDetails.controls['phoneNumber'].disable();
        this.smsDetails.controls['message'].patchValue(this.smsObj.message);
        this.smsDetails.controls['message'].disable();
      }
  }

  sendSMS(){

    this.sendingSMS = true;

    this.smsService.sendSMS(this.caseId, this.smsDetails.value).subscribe((response : any) => {
      this.activeModal.close(true);
      this.correspondenceTimelineService.refreshCaseTimeline.next();
    });

  }

}
